module.exports = __webpack_public_path__ + "static/media/logo-aortic.a1291b02.png";